import {
  EnhancedHeaderInputTypes,
  EnhancedTableHeader,
  EnhancedTableHeaderType
} from '@components/table/widgets/shared-with-old';

export const getMedicalGroupInsuredDetailsHeaders: (
  currency: string,
  disabled: boolean
) => Record<string, EnhancedTableHeader> = (
  currency: string,
  disabled: boolean
): Record<string, EnhancedTableHeader> => {
  const headers: Record<string, EnhancedTableHeader> = {
    certificateNumber: {
      name: 'policyNumber',
      title: 'Certificate Number',
      type: EnhancedTableHeaderType.Text,
      filterField: 'policy.policyNumber'
    },
    insuredName: {
      name: 'insuredName',
      title: 'Insured Name',
      type: EnhancedTableHeaderType.Text,
      filterField: 'policyPerson.person.fullName'
    },
    relation: {
      name: 'relation',
      title: 'Relation',
      type: EnhancedTableHeaderType.Text,
      filterField: 'policyPerson.relation'
    },
    age: {
      name: 'age',
      title: 'Age',
      type: EnhancedTableHeaderType.Text,
      filterField: 'policyPerson.age'
    },
    cover: {
      name: 'cover',
      title: 'Cover',
      type: EnhancedTableHeaderType.Text,
      filterField: 'policyPlanCover.cover.code'
    },
    sumInsured: {
      name: 'sumInsured',
      title: 'Sum Insured',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    netPremium: {
      name: 'netPremium',
      title: 'Net Premium',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    netPremiumVariance: {
      name: 'netPremiumVariance',
      title: 'Net Premium Variance',
      type: EnhancedTableHeaderType.Input,
      inputType: EnhancedHeaderInputTypes.RoundedCurrency,
      currency: currency,
      allowNegative: true,
      disabled,
      disableSort: true,
      // LOV: [-{CoverNetPremium}, 0]
      // minValue set dynamically based on row.netPremium
      maxValue: 0
    },
    charges: {
      name: 'charges',
      title: 'Charges',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    chargesVariance: {
      name: 'chargesVariance',
      title: 'Charges Variance',
      type: EnhancedTableHeaderType.Input,
      inputType: EnhancedHeaderInputTypes.RoundedCurrency,
      currency: currency,
      allowNegative: true,
      disabled,
      disableSort: true,
      // LOV: [-{CoverCharges}, 0]
      // minValue set dynamically based on row.charges
      maxValue: 0
    },
    tpaFees: {
      name: 'tpaFees',
      title: 'TPA Fees',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    tpaFeesVariance: {
      name: 'tpaFeesVariance',
      title: 'TPA Fees Variance',
      type: EnhancedTableHeaderType.Input,
      inputType: EnhancedHeaderInputTypes.RoundedCurrency,
      currency: currency,
      allowNegative: true,
      disabled,
      disableSort: true,
      // LOV: [-{CoverTPAFees}, 0]
      // minValue set dynamically based on row.tpaFees
      maxValue: 0
    },
    grossPremium: {
      name: 'grossPremium',
      title: 'Gross Premium',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    grossPremiumVariance: {
      name: 'grossPremiumVariance',
      title: 'Gross Premium Variance',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    coverProportionalVariance: {
      name: 'coverProportionalStamp',
      title: 'CoverProportionalVariance',
      type: EnhancedTableHeaderType.Text,
      disableSort: true,
      hidden: true
    },
    coverMunicipalityVariance: {
      name: 'coverMunicipalityTax',
      title: 'CoverMunicipalityVariance',
      type: EnhancedTableHeaderType.Text,
      disableSort: true,
      hidden: true
    },
    totalPremium: {
      name: 'totalPremium',
      title: 'Total Premium',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    totalPremiumVariance: {
      name: 'totalPremiumVariance',
      title: 'Total Premium Variance',
      type: EnhancedTableHeaderType.RoundedCurrency,
      currency: currency,
      disableSort: true
    },
    insuredPPCoverPeriod: {
      name: 'insuredPPCoverPeriod',
      title: 'InsuredPPCoverPeriod',
      type: EnhancedTableHeaderType.Text,
      disableSort: true,
      hidden: true
    },
    cancelledPeriod: {
      name: 'cancelledPeriod',
      title: 'Cancelled Period',
      type: EnhancedTableHeaderType.Text,
      disableSort: true,
      hidden: true
    },
    activeDays: {
      name: 'activeDays',
      title: 'Active Days',
      type: EnhancedTableHeaderType.Text,
      disableSort: true,
      hidden: true
    }
  };

  return headers;
};
